import gql from "graphql-tag";
import {
  deviceFields,
  incidentFields,
  organizationFields,
} from "../../graphql/fragments";

/**
 * include organization responders to filter only assigned units
 * see https://github.com/teamofdefenders/sd_frontend/pull/113
 */
export const DASHBOARD_COUNT_INCIDENTS = gql`
  query DashboardCountIncidents(
    $parentId: ID!
    $authorized: Boolean
    $after: DateTime
  ) {
    incidents(
      parentId: $parentId
      authorized: $authorized
      dateTimeFilter: { after: $after }
      assigned: true
      demonstration: false
    ) {
      id
      startedAt
      tasks {
        dueAt
      }
    }
  }
`;

export const DASHBOARD_RECENT_INCIDENTS = gql`
  query DashboardRecentIncidents(
    $parentId: ID!
    $after: DateTime!
    $organizationSubtype: String
    $concerning: Boolean
  ) {
    incidents(
      parentId: $parentId
      dateTimeFilter: { after: $after }
      organizationSubtype: $organizationSubtype
      concerning: $concerning
      demonstration: false
      sort: "startedAt desc"
    ) {
      ...IncidentFields
      survey
      organization {
        id
        name
        type
      }
    }
  }
  ${incidentFields}
`;

export const DASHBOARD_INCIDENTS_DETAILED = gql`
  query DashboardIncidentsDetailed(
    $parentId: ID!
    $authorized: Boolean
    $after: DateTime
  ) {
    incidents(
      parentId: $parentId
      authorized: $authorized
      dateTimeFilter: { after: $after }
      assigned: true
      demonstration: false
      sort: "startedAt desc"
    ) {
      ...IncidentFields
      devices {
        id
        externalId
        shortId
        name
        organization {
          id
          name
        }
      }
      survey
      organization {
        id
        name
        type
        devices {
          ...DeviceFields
        }
        responders {
          user {
            id
            firstName
            lastName
          }
        }
      }
      tasks {
        id
        taskId
        description
        dueAt
        insertedAt
        priority
        resolution
        title
        updatedAt
        assignee {
          id
          firstName
          lastName
          username
        }
      }
    }
  }
  ${incidentFields}
  ${deviceFields}
`;

export const DASHBOARD_COUNT_ZONE_INCIDENTS = gql`
  query DashboardCountZoneIncidents($parentId: ID!, $after: DateTime) {
    incidents(
      parentId: $parentId
      dateTimeFilter: { after: $after }
      organizationSubtype: "zone"
    ) {
      id
      type
      startedAt
      organization {
        id
        devices {
          id
          type
          subtype
        }
      }
    }
  }
`;

export const DASHBOARD_ZONE_INCIDENTS = gql`
  query DashboardZoneIncidents($parentId: ID!, $after: DateTime) {
    incidents(
      parentId: $parentId
      dateTimeFilter: { after: $after }
      sort: "startedAt desc"
      organizationSubtype: "zone"
    ) {
      ...IncidentFields
      organization {
        id
        name
        type
      }
    }
  }
  ${incidentFields}
`;

export const DASHBOARD_MONITORING_CONTROL_HUB_STATS_ITEM = gql`
  query MonitoringControlHubStatsItem($organizationIds: [ID!]) {
    monitoringControlHubStats(organizationIds: $organizationIds) {
      currentIncidents
      inProgressIncidents
      inProgressOverdueIncidents
      inProgressTasks
      inReviewIncidents
      openIncidents
      openTasks
      overdueIncidents
      overdueTasks
    }
  }
`;
